import React, { useEffect, useRef } from "react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../../ui/carousel";
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  images: string[];
}

const GalleryModal: React.FC<ModalProps> = ({ isOpen, onClose, images }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 h-[100vh] m-0 bg-black/70 bg-opacity-10 flex items-center justify-center z-[120] p-10">
      <div className="bg-transparent w-fit rounded-lg animate-in fade-in duration-200 p-5">
        <div className="md:p-12" ref={modalRef}>
          <Carousel className="w-full max-w-3xl">
            <CarouselContent>
              {images.map((image, index) => (
                <CarouselItem
                  key={image}
                  className="flex items-center justify-center"
                >
                  <div className="flex justify-center items-center">
                    <img
                      src={image}
                      alt=""
                      className="bg-cover w-auto rounded-lg"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="px-10">
              <CarouselPrevious />
              <CarouselNext />
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;
